import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import moment from 'moment/moment';

import "./curriculumList.css";
import SideBar from "../../commanComponents/sidebar/sidebar";
import { clearData } from '../../../utils/localStorage';
import TopNavigation from "../../commanComponents/topNavigation/topNavigation";
import { ROUTES, sidebarNavItems, DATA_NOT_FOUND } from '../../../constant';
import { getCompletedTopicsListService, getSessionListService } from "../../../modules/services";
import SkeletonLoading from '../../commanComponents/skeletonLoading/skeletonLoading';
import { titleCase } from '../../../utils/utils';
import DateRangeFilterInput from "../../commanComponents/dateRangeFilterInput/dateRangeFilterInput";


const CurriculumList = () => { 
    const [dataList, setDataList] = useState([]);
    const [sessionData, setSessionData] = useState([]);
    const [startDate, setStartDate] = useState(moment().date(1).toDate());
    const [endDate, setEndDate] = useState(moment().toDate());
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const FilterSchema = z.object({
        //session_filter
        session_filter: z.string(),
        //school_filter
        school_filter: z.string(),
        //class_filter
        class_filter: z.string(),
        //section_filter
        section_filter: z.string(),
    });
    const {getValues: filterGetValues, setValue: filterSetValue } = useForm({
        resolver: zodResolver(FilterSchema)
    });

    const renderDropdownListData = (listData, label, value, id) => {
        return(listData.map(data => ({label: data[label], value: data[value], id: data[id]})))
    }

    const getCurriculumListData = (_startDate, _endDate) => {
        const sessionFilterData = filterGetValues("session_filter");
        let thisStartDate = _startDate ? _startDate : startDate
        thisStartDate = thisStartDate.getFullYear() + "-" + ("0" + (thisStartDate.getMonth() + 1)).slice(-2) + "-" + ("0" + thisStartDate.getDate()).slice(-2)
        let thisEndDate = _endDate ? _endDate : endDate
        thisEndDate = thisEndDate.getFullYear() + "-" + ("0"+(thisEndDate.getMonth()+1)).slice(-2) + "-" + ("0" + thisEndDate.getDate()).slice(-2)
        console.log(thisStartDate)

        setIsLoading(true);
        (async () => {
            const responseData = await getCompletedTopicsListService({
                remove_pagination: true,
                session: sessionFilterData,
                event_start_date: thisStartDate,
                event_end_date: thisEndDate
            });
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setDataList(responseData.data);

                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
                toast.error(responseData.data.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            else {
                clearData();
                toast.error(responseData.data.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                });
                navigate(ROUTES.LOGIN);
            }
        })();
    };

    const getSessionData = () => { 
        setIsLoading(true);
        (async () => {
            const responseData = await getSessionListService({pagination: false});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                const sessionList = renderDropdownListData(responseData.data, "session_name", "id", "id");
                setSessionData(sessionList);
                filterSetValue("session_filter", sessionList[0]?.value);
                getCurriculumListData();
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    const handleDateFilter = (startDate, endDate) => { 
        if (startDate && endDate) { 
            setStartDate(startDate);
            setEndDate(endDate);
            
            getCurriculumListData(startDate, endDate);
        }
    }

    useEffect(() => {
        getSessionData();
    }, []);

    return (
        <div className='curriculum-list-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.adminCurriculum} />
            <div className='curriculum-list-side-container'>
                <TopNavigation activeItem={sidebarNavItems.adminCurriculum} />
                
                <div className='row curriculum-list-filter-container'>
                    <div className='col-xd curriculum-list-filter-col'>
                        <DateRangeFilterInput label="Date Filter" onChange={handleDateFilter} defaultStartDate={startDate} defaultEndDate={endDate}/>
                    </div>
                </div>
                
                <div className='curriculum-list-main-container'>
                    {
                        dataList.length !== 0
                            ?
                            dataList.map((data, index) => {
                                if (data.holiday_session) {
                                    return (
                                        <div className='curriculum-list-card' style={{ backgroundColor: "#e9a7a752" }} key={index}>
                                            <div className='row'>
                                                <div className='col'>
                                                    <label className='curriculum-list-card-topic'>
                                                        {
                                                            data.full_day_leave 
                                                                ? 
                                                                data.full_day_leave === "OTHER"
                                                                    ?
                                                                    data.other_comment
                                                                    :
                                                                    titleCase(data.full_day_leave) 
                                                                :
                                                                data.period_vise_leave === "OTHER"
                                                                    ?
                                                                    data.other_comment
                                                                    :
                                                                    titleCase(data.period_vise_leave)
                                                        }
                                                    </label><br />
                                                    <label className='curriculum-list-card-chapter'>{data.full_day_leave ? "Full day" : titleCase(data.event_period)}</label>
                                                </div>
                                                <div className='col-lg-3 col-sm-6'>
                                                    <label>Date: {data.event_date}</label><br />
                                                    <label style={{marginTop: "10px"}}>Mentor Name: {data.mentor_first_name} {data.mentor_last_name}</label>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }
                                else if (data.task_session) { 
                                    return (
                                        <div className='curriculum-list-card' key={index}>
                                            <div className='row'>
                                                <div className='col'>
                                                    <label className='curriculum-list-card-topic'>{ data.custom_topic_name ? "Custom Topic: " + data.custom_topic_name : "Topic: " + data.topic_name}</label><br />
                                                    <label className='curriculum-list-card-chapter'>Chapter: {data.chapter_name ? data.chapter_name : "N/A"}</label><br />
                                                    <label className='curriculum-list-card-chapter'>Module: {data.curriculum_name ? data.curriculum_name : "N/A"}</label>
                                                </div>
                                                <div className='col-lg-3 col-sm-6'>
                                                    <label>Date: {data.event_date}</label><br />
                                                    <label style={{marginTop: "10px"}}>Mentor Name: {data.mentor_first_name} {data.mentor_last_name}</label>
                                                </div>
                                            </div>
                                            {
                                                data.user_class
                                                ?
                                                <div className='row'>
                                                    <div className='row'>
                                                        <div className='col-lg col-md-4 col-sm-4' style={{textAlign: "center"}}>
                                                            <label className='curriculum-list-card-attendance-title'>Class/Section</label><br />
                                                            <label style={{ fontSize: "30px" }}>{data.user_class}/{data.section}</label>
                                                        </div>
                                                        <div className='col-lg col-md-4 col-sm-4' style={{textAlign: "center"}}>
                                                            <label className='curriculum-list-card-attendance-title'>Present Students</label><br />
                                                            <label style={{fontSize: "30px"}}>{data.present_count}</label>
                                                        </div>
                                                        <div className='col-lg col-md-4 col-sm-4' style={{textAlign: "center"}}>
                                                            <label className='curriculum-list-card-attendance-title'>Absent Students</label><br />
                                                            <label style={{fontSize: "30px"}}>{data.absent_count}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <></>
                                            }
                                            
                                        </div>
                                    );
                                }
                            })
                            :
                            isLoading
                                ?
                                [1, 2].map((data, index) => { 
                                    return (
                                        <div className='curriculum-list-card' key={index}>
                                            <div className='row'>
                                                <div className='col'>
                                                    <label className='curriculum-list-card-topic'><SkeletonLoading customStyle={{width: "150px"}} /></label><br />
                                                    <label className='curriculum-list-card-chapter'><SkeletonLoading customStyle={{width: "100px"}} /></label>
                                                </div>
                                                <div className='col-3'>
                                                    <label><SkeletonLoading customStyle={{width: "100px"}} /></label><br />
                                                    <label style={{marginTop: "10px"}}><SkeletonLoading customStyle={{width: "150px"}} /></label>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='row'>
                                                    <div className='col' style={{textAlign: "center"}}>
                                                        <label className='curriculum-list-card-attendance-title'><SkeletonLoading customStyle={{width: "100px", height: "80px"}} /></label><br />
                                                    </div>
                                                    <div className='col' style={{textAlign: "center"}}>
                                                        <label className='curriculum-list-card-attendance-title'><SkeletonLoading customStyle={{width: "100px", height: "80px"}} /></label><br />
                                                    </div>
                                                    <div className='col' style={{textAlign: "center"}}>
                                                        <label className='curriculum-list-card-attendance-title'><SkeletonLoading customStyle={{width: "100px", height: "80px"}} /></label><br />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                                :
                                <div style={{textAlign: "center"}}>
                                    <img src={DATA_NOT_FOUND} alt='no record found' style={{ maxWidth: "500px", marginTop: "5%" }} />
                                    <h2>No Data Found</h2>
                                </div>
                    }
                </div>
            </div>
        </div>
    );
}


export default CurriculumList;
